<form [formGroup]="frm">
  <div class="formgrid grid border anagrafica mb-3">
    <div class="col-12">
      <h3>Informazioni anagrafiche</h3>
    </div>
    <div class="field col-12 md:col-4">
      <label>Nome*</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="name" />
      <app-form-errors
        *ngIf="frm.get('name')?.errors && frm.get('name')?.dirty"
        [errors]="frm.get('name')?.errors"></app-form-errors>
    </div>
    <div class="field col-12 md:col-4">
      <label>Cognome*</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="last_name" />
      <app-form-errors
        *ngIf="frm.get('last_name')?.errors && frm.get('last_name')?.dirty"
        [errors]="frm.get('last_name')?.errors"></app-form-errors>
    </div>
    <div class="field col-12 md:col-4">
      <label>Mansione</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="job_title" />
    </div>
  </div>
  <div class="formgrid grid contatto mb-3">
    <div class="col-12">
      <h3>Informazioni di contatto</h3>
    </div>
    <div class="field col-12 md:col-12">
      <label>Fax</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="fax_number" />
    </div>
    <div class="field col-12 md:col-3">
      <label>Email</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="email" />
      <app-form-errors
        *ngIf="frm.get('email')?.errors && frm.get('email')?.dirty"
        [errors]="frm.get('email')?.errors"></app-form-errors>
    </div>
    <div class="field col-12 md:col-3">
      <label>Email (2)</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="alternative_email" />
      <app-form-errors
        *ngIf="frm.get('alternative_email')?.errors && frm.get('alternative_email')?.dirty"
        [errors]="frm.get('alternative_email')?.errors"></app-form-errors>
    </div>
    <div class="field col-12 md:col-3">
      <label>Telefono</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="phone_number" />
    </div>
    <div class="field col-12 md:col-3">
      <label>Telefono (2)</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="alternative_phone_number" />
    </div>
  </div>
  <div class="formgrid grid indirizzi mb-3">
    <div class="col-12">
      <h3>Informazioni di indirizzo</h3>
    </div>
    <div class="field col-12 md:col-6">
      <label>Indirizzo</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="address" />
    </div>
    <div class="field col-12 md:col-2">
      <label>Città</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="city" />
    </div>
    <div class="field col-12 md:col-2">
      <label>Provincia</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="province" />
    </div>
    <div class="field col-12 md:col-2">
      <label>CAP</label>
      <p-inputMask
        mask="99999"
        [maxlength]="5"
        type="text"
        styleClass="w-full"
        formControlName="zip_code" />
    </div>
    <div class="field col-12 md:col-3">
      <label>Edificio</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="building" />
    </div>
    <div class="field col-12 md:col-3">
      <label>Scala</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="directions" />
    </div>
    <div class="field col-12 md:col-3">
      <label>Piano</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="floor" />
    </div>
    <div class="field col-12 md:col-3">
      <label>Stanza</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="room" />
    </div>
  </div>
  <div class="formgrid grid anagrafica mb-3">
    <div class="col-12">
      <h3>Informazioni agguntive</h3>
    </div>
    <div class="field col-12 md:col-12">
      <label>Profilo LinkedIn</label>
      <input
        pInputText
        type="text"
        class="w-full"
        formControlName="linkedin_url" />
    </div>
    <div class="field col-12">
      <label>Note</label>
      <textarea
        rows="5"
        class="w-full"
        pInputText
        formControlName="notes"></textarea>
    </div>
  </div>
</form>
<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      label="Annulla"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      [label]="'Salva'"
      type="submit"
      styleClass="butt"
      [rounded]="true"
      [disabled]="frm.invalid"
      (click)="save()"></p-button>
  </div>
</div>
